export interface ExternalPropertyLink {
  href: string;
  hostname: string;
}

export function resolveExternalPropertyLink(
  value: unknown
): ExternalPropertyLink | null {
  if (typeof value !== "string" || !value.trim()) return null;

  const raw = value.trim();
  const candidates = [raw];
  try {
    const decoded = decodeURIComponent(raw);
    if (decoded !== raw) candidates.push(decoded);
  } catch {
    // A malformed encoded URL is still allowed to try as a literal URL below.
  }

  for (const candidate of candidates) {
    try {
      const parsed = new URL(candidate);
      if (!['http:', 'https:'].includes(parsed.protocol)) continue;
      if (!parsed.hostname || parsed.username || parsed.password) continue;
      return {
        href: parsed.toString(),
        hostname: parsed.hostname.replace(/^www\./i, ""),
      };
    } catch {
      // Try the next representation.
    }
  }

  return null;
}
